import React from 'react';

import { Messages } from '../../../../codegen/Localize';
import { DetailsTooltipStyles } from '../../CardView/DetailsTooltipStyles';

export interface MetricComparisonInfoProps {
  comparison: string;
}

export function MetricComparisonInfo(props: MetricComparisonInfoProps) {
  return (
    <div className={DetailsTooltipStyles.MetadataSection}>
      <span className={DetailsTooltipStyles.MetadataTitle}>{Messages.metricComparedVersusTooltip()}</span>
      <span className={DetailsTooltipStyles.MetadataValue}>{ props.comparison }</span>
    </div>
  );
}

